import {useContext} from 'react';

import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import {Box, IconButton, TableCell} from '@mui/material';

import {BasicTableCell, BasicTableRow} from '../../../../../components/BasicTable/BasicTableRow';
import {TextOverflowWithTooltip} from '../../../../../components/TextOverflowWithTooltip/TextOverflowWithTooltip';
import {LanguageContext} from '../../../../../contexts/LanguageContext/LanguageContext';
import {DepartmentTargetProfileAssignment} from '../../types/DepartmentTargetProfileTypes';

export interface Props extends DepartmentTargetProfileAssignment {
  onView: (assignmentId: string) => void;
  onDelete: (assignmentId: string) => void;
  viewLabel: string;
  deleteLabel: string;
}

export const DepartmentTargetProfileRow = ({
  resourceId,
  title,
  occupationTitle,
  professionalArea,
  onView,
  onDelete,
  viewLabel,
  deleteLabel,
}: Props) => {
  const currentLanguage = useContext(LanguageContext);

  return (
    <BasicTableRow rowVariant='flat'>
      <BasicTableCell>
        <TextOverflowWithTooltip variant='body2' text={title} />
      </BasicTableCell>
      <BasicTableCell>
        <TextOverflowWithTooltip variant='body2' text={occupationTitle ?? ''} />
      </BasicTableCell>
      <BasicTableCell>
        <TextOverflowWithTooltip variant='body2' text={professionalArea.name[currentLanguage]} />
      </BasicTableCell>
      <TableCell align='right' sx={{borderBottom: '1px solid', borderColor: 'divider', py: 1}}>
        <Box sx={{display: 'flex', justifyContent: 'flex-end', gap: 0.5}}>
          <IconButton aria-label={viewLabel} size='small' onClick={() => onView(resourceId)}>
            <VisibilityOutlinedIcon fontSize='small' />
          </IconButton>
          <IconButton aria-label={deleteLabel} size='small' onClick={() => onDelete(resourceId)}>
            <DeleteOutlineIcon fontSize='small' />
          </IconButton>
        </Box>
      </TableCell>
    </BasicTableRow>
  );
};
